module.exports = __webpack_public_path__ + "static/media/woocommerce.2f022baf.png";